
import AdminMobileNav from '@/components/mobile/AdminMobileNav.vue'

export default {
  name: 'AdminMobileDashboard',
  components: {
    AdminMobileNav
  },
  data () {
    return {
      stats: {
        productCount: 0,
        orderCount: 0
      }
    }
  },
  created () {
    this.fetchStats()
  },
  methods: {
    async fetchStats () {
      try {
        // 并行获取统计数据
        const [productsRes, ordersRes] = await Promise.all([
          this.axios.get('/admin/products'),
          this.axios.get('/admin/orders')
        ])

        if (productsRes.data.code === 200) {
          this.stats.productCount = productsRes.data.pagination?.total || 0
        }

        if (ordersRes.data.code === 200) {
          this.stats.orderCount = ordersRes.data.pagination?.total || 0
        }
      } catch (err) {
        console.error('获取统计失败:', err)
      }
    }
  }
}
